import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "preventivatore-result-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "webins-row mt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex text-muted" })
], -1)
const _hoisted_3 = {
  class: "webins-row d-flex",
  style: {"justify-content":"space-around"}
}
const _hoisted_4 = {
  key: 0,
  class: "result-list-empty"
}

import { computed, defineComponent, onMounted, ref } from "vue";
import { usePolizze, useNavigation, useWidget } from "@/composables";
import Collapsible from "@/components/collapsible.vue";
import IconCircle from "@/components/icon-circle.vue";
import CheckCategoriaParametri from "@/components/checkCategoriaParametri.vue";
import CheckParametri from "@/components/checkParametri.vue";
import ProdottoCarrello from "@/components/prodotto-carrello.vue";
import ProdottoCarrelloCard from "@/components/prodotto-carrello-card.vue";
import Popup from "@/components/popup.vue";
import { gruppoSchedaProdottoParametri } from "@/models/AssociaDistributoriPacchetti";
import WebinsService from "@/services/WebinsService";
//import ResultList from "./result-list.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { loading, risultatiPreventivatore, parametriSchedaPreventivatore } = usePolizze();
const { isAppMobile, options } = useWidget();

const categorieEspanse = ref<string[]>([]);

onMounted(async () => {
    /*var self = this;
    eventHub.$on(
        eventHub.events.PRODUCT_SEARCHED,
        () => self.changeProdottiScroll()
    );

    eventHub.$on(
        eventHub.events.TOGGLE_PREFERITI,
        async () => {
            self.togglePreferiti();
        }
    );*/
});

const parametriConValori = computed(() => {
    // gruppoSchedaProdottoParametri
    if (parametriSchedaPreventivatore.value == null) return [];
    return parametriSchedaPreventivatore.value.filter((x) => parametroHasValori(x));
});

const risultatiPreventivatoreFiltrati = computed(() => {
    if(!options.value.prodotti || !options.value.prodotti.length)
        return risultatiPreventivatore.value;
    var filtrati = risultatiPreventivatore.value.filter((obj) => {
        return options.value.prodotti.includes(obj.pacchettoID);
    })
    return filtrati;
});

const parametroHasValori = (parametro: gruppoSchedaProdottoParametri) => {
    if (risultatiPreventivatore == null || risultatiPreventivatore.value == null || risultatiPreventivatore.value.length == 0) return false;
    // basta che ci sia almeno un prodotto con almeno un parametro valorizzato per categoria del parametro in questione [quello passato al metodo]
    return risultatiPreventivatore.value.find((p) => p.parametri.find((pp) => pp.categoria == parametro.categoria && pp.valore && pp.valore != "0")) != null;
};

const expandCategoria = (categoria) => {
    if (categorieEspanse.value.indexOf(categoria) == -1) categorieEspanse.value.push(categoria);
    else categorieEspanse.value = categorieEspanse.value.filter((x) => x != categoria);
    // Vue.set(this.categorie, categoria, !this.categorie[categoria]);
};

const isCategoriaEspanded = (categoria) => {
    return categorieEspanse.value.find((x) => x == categoria) != null;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(risultatiPreventivatoreFiltrati), (prodotto) => {
        return (_openBlock(), _createElementBlock("div", {
          key: prodotto.itemID,
          class: "d-flex webins-card-polizza",
          style: {"margin":"5px"}
        }, [
          _createVNode(ProdottoCarrelloCard, {
            prodotto: prodotto,
            parametri: _unref(parametriConValori)
          }, null, 8, ["prodotto", "parametri"])
        ]))
      }), 128))
    ]),
    (_unref(risultatiPreventivatoreFiltrati) == null || _unref(risultatiPreventivatoreFiltrati).length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Nessuna disponibilità per i parametri impostati."))
      : _createCommentVNode("", true)
  ]))
}
}

})